.summary {
  margin: 0 0 var(--space-4);
  padding: var(--space-3) var(--space-4);
  background: var(--bg-surface);
  border-radius: var(--radius-md);
  font-size: var(--text-md);
  line-height: 1.6;
  color: var(--text-secondary);
}

.emph {
  font-weight: var(--weight-semi);
  color: var(--text-primary);
  font-variant-numeric: tabular-nums;
}

.purple {
  color: var(--metric-retained);
}

.teal {
  color: var(--metric-acquired);
}
